import { useEffect } from 'react';

import { dbg } from '@/lib/logto';
import { haProfiloPerGioco, syncAllApertura } from '@/lib/limulo/registration';
import {
  useGetLimuloGameProfileRequirementsQuery,
  useGetLimuloProfilesQuery,
  usePostLimuloProfileSyncMutation,
} from '@/services/limuloApi';

/**
 * orc44, sede 2 del sync: all'apertura di una scheda torneo o incontro, se l'utente ha un profilo
 * ATTIVO per il gioco del torneo e lo schema di quel gioco e' a ZERO campi, chiede il sync del
 * provider — una volta per profilo e per sessione. Regola, Set e reperto in
 * `lib/limulo/registration.ts` (`syncAllApertura`, `sincronizzaProfilo`).
 *
 * 🔴 Serve ai profili nati PRIMA della cura: creati col profilo implicito (#377) senza sync, hanno
 * `meta.provider` senza `sub`, e la partita esterna nasce in `conflict` (`sub_missing`).
 * ⚠️ Fire-and-forget: non restituisce niente e un errore non tocca la UI (va nel registro `dbg`, e dal kb#388 anche in
 * `esitoSyncDi`: e' li' che il TOCCO di Invia/Accetta legge se il sync e' andato, `useCollegamentoProfilo`).
 * ⚠️ Le letture sono le stesse del pannello d'iscrizione (stessi argomenti ⇒ stessa cache RTK):
 * la lista dei profili non costa una GET in piu'. Lo schema si chiede SOLO se un profilo per quel
 * gioco c'e': chi non ne ha non paga niente.
 */
export function useSyncProfiloLimulo(gameId: string): void {
  const profiliQuery = useGetLimuloProfilesQuery(undefined, { skip: gameId === '' });
  const haProfilo = haProfiloPerGioco(profiliQuery.data, gameId) === true;
  const schemaQuery = useGetLimuloGameProfileRequirementsQuery(gameId, {
    skip: gameId === '' || !haProfilo,
  });
  const [sync] = usePostLimuloProfileSyncMutation();
  const profili = profiliQuery.data;
  const requisiti = schemaQuery.data;

  useEffect(() => {
    // Il Set di modulo dentro `syncAllApertura` e' cio' che impedisce la ripetizione: questo
    // effetto rigira a ogni rilettura della lista (compresa quella che il sync stesso provoca).
    syncAllApertura({
      profili,
      gameId,
      requisitiGioco: requisiti,
      sync: (profileId) => sync(profileId),
      log: dbg,
    });
  }, [profili, requisiti, gameId, sync]);
}
